import React from 'react';
import { ApartmentIcon as StyledApartmentIcon } from './ApartmentIcon.styled';

export interface ApartmentIconProps {
  className?: string;
}

export function ApartmentIcon({ className }: ApartmentIconProps) {
  return <StyledApartmentIcon className={className} />;
}
